import { render, staticRenderFns } from "./releaseIncubatorDetail.vue?vue&type=template&id=0551e9ac&scoped=true&"
import script from "./releaseIncubatorDetail.vue?vue&type=script&lang=js&"
export * from "./releaseIncubatorDetail.vue?vue&type=script&lang=js&"
import style0 from "./releaseIncubatorDetail.vue?vue&type=style&index=0&id=0551e9ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0551e9ac",
  null
  
)

export default component.exports